import React, { useRef } from 'react'
import { BehaviorSubject } from 'rxjs'
import ReactPlayerLoader from '@brightcove/react-player-loader'
let videoPlayerRef = null
const fn = () => {}
export default function BrightcovePlayer({
  accountId = '1625296066001',
  videoId,
  playlistId,
  options,
  playerId,
  onVideoPlayCallback = fn,
  onVideoPauseCallback = fn,
  onVideoEndCallback = fn,
  onVideoLoadStartCallback = fn,
  attrs,
}) {
  const userInitiatedRef = useRef(false)
  const playFunctionIscalled = useRef(false)
  const videoref = videoId ? videoId : playlistId
  if (!videoPlayerRef) {
    videoPlayerRef = new BehaviorSubject({})
  }

  const otherVideoStop = () => {
    const playerRefs = videoPlayerRef?.value || {}
    const otherPlayerRef = Object.keys(playerRefs)?.filter(
      (i) => i !== videoref
    )
    if (otherPlayerRef && otherPlayerRef.length > 0) {
      otherPlayerRef.forEach((id) => {
        stopOtherVideo(playerRefs[id])
      })
    }
  }

  const stopOtherVideo = (player) => {
    player.pause()
    player.autoplay(false)
    reloadThePoster(player)
  }

  const reloadThePoster = (player) => {
    const playId = videoId ? 'videoId' : 'playlistId'
    const playfn = videoId ? 'getVideo' : 'getPlaylist'
    player.catalog[playfn](player?.el_?.dataset[playId], (error, video) => {
      if (error) {
        console.error('Error loading video:', error)
        return
      }
      player.catalog.load(video)
    })
  }

  const reloadInteractivity = () => {
    setTimeout(() => {
      window?.dispatchEvent(new Event('resize'))
    }, 800)
  }

  const onLoadStart = (e) => {
    e.target.player.muted(false)
    const prevVideoPlayerRef = videoPlayerRef?.value || {}
    const newVideoPlayerRef = {
      ...prevVideoPlayerRef,
      [videoref]: e.target.player,
    }
    videoPlayerRef?.next(newVideoPlayerRef)
    onVideoLoadStartCallback(e.target.player.mediainfo)
    const playButton = e.target.player.el_
    if (playButton) {
      playButton.addEventListener('click', () => {
        userInitiatedRef.current = true
      })
    }
  }

  const onVideoPlay = () => {
    playFunctionIscalled.current = true
    otherVideoStop()
    onVideoPlayCallback()
    reloadInteractivity()
  }

  const onVideoPause = (e) => {
    playFunctionIscalled.current = false
    const timerOut = setTimeout(() => {
      if (playFunctionIscalled.current) {
        clearTimeout(timerOut)
      } else {
        userInitiatedRef.current = false
        onVideoPauseCallback()
        reloadThePoster(e?.target?.player)
        reloadInteractivity()
      }
    }, 500)
  }

  const onVideoEnd = () => {
    onVideoEndCallback()
  }

  const onSuccess = (e) => {
    e.ref.on('play', () => {
      if (userInitiatedRef.current) {
        onVideoPlay()
      } else {
        stopOtherVideo(e.ref)
      }
    })
    e.ref.on('pause', onVideoPause)
    e.ref.on('ended', onVideoEnd)
    e.ref.on('loadstart', onLoadStart)
  }

  return (
    <ReactPlayerLoader
      accountId={accountId}
      videoId={videoId}
      playerId={playerId}
      playlistId={playlistId}
      onSuccess={onSuccess}
      attrs={{ ...attrs }}
      options={options}
    />
  )
}
